export const sessonDao = {
  get(key, df) {
    // console.trace()
    let val = sessionStorage.getItem(key)
    try {
      val = JSON.parse(sessionStorage.getItem(key))
    } catch (e) {
      console.log('%c sessonDao.get@' + key + '错误', 'color:#ed4014')
      val = df !== undefined ? df : null
    }
    return val
  },
  set(key, value) {
    let val
    try {
      val = JSON.stringify(value)
    } catch (e) {
      console.log('%c sessonDao.set@' + key + '错误', 'color:#ed4014')
    }
    sessionStorage.setItem(key, val)
  },
  remove(key) {
    sessionStorage.setItem(key, '')
  },

  getString(key, df) {
    let val = sessionStorage.getItem(key)
    return val ? val : (df !== undefined ? df : val)
  },
  setString(key, value) {
    sessionStorage.setItem(key, value)
  },

  /**
   * 获取 Boolean 类型
   * storage中的值与 Boolean 关系如下
   * null     -> false
   * "0"      -> false
   * "false"  -> false
   * ""       -> false
   * " "      -> false
   * 其他全部为 true
   **/
  getBoolean(key) {
    let val = sessionStorage.getItem(key);
    return !(val === null || val === "0" || val.trim() === "" || val === "false");
  },

  setBoolean(key, val){
    sessionStorage.setItem(key, val);
    return sessonDao.getBoolean(key);
  },

  clearAll: _ => sessonDao.clear()
}

export const localDao = {
  get(key, df) {
    // console.trace()
    let val = localStorage.getItem(key)
    try {
      val = JSON.parse(localStorage.getItem(key))
    } catch (e) {
      console.log('%c sessonDao.get@' + key + '错误', 'color:#ed4014')
      val = df !== undefined ? df : null
    }
    return val
  },
  set(key, value) {
    let val
    try {
      val = JSON.stringify(value)
    } catch (e) {
      console.log('%c sessonDao.set@' + key + '错误', 'color:#ed4014')
    }
    localStorage.setItem(key, val)
  },
  remove(key) {
    localStorage.setItem(key, '')
  },
  getString(key, df) {
    let val = localStorage.getItem(key)
    return val ? val : (df !== undefined ? df : val)
  },
  setString(key, value) {
    localStorage.setItem(key, value)
  },
  clearAll: _ => localStorage.clear()
}

export const cookieDao = {
  get(key, df) {
    // console.trace()
    let val = localStorage.getItem(key)
    try {
      val = JSON.parse(localStorage.getItem(key))
    } catch (e) {
      console.log('%c sessonDao.get@' + key + '错误', 'color:#ed4014')
      val = df !== undefined ? df : null
    }
    return val
  },
  set(key, value) {
    let val
    try {
      val = JSON.stringify(value)
    } catch (e) {
      console.log('%c sessonDao.set@' + key + '错误', 'color:#ed4014')
    }
    localStorage.setItem(key, val)
  },
  remove(key) {
    localStorage.setItem(key, '')
  },
  getString(key, df) {
    let val = localStorage.getItem(key)
    return val ? val : (df !== undefined ? df : val)
  },
  setString(key, value) {
    localStorage.setItem(key, value)
  },
  clearAll: _ => localStorage.clear()
}

export default {
  cookieDao,
  sessonDao,
  localDao
}
